import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { Typography } from 'src/typography';
import {
  FormTextInput as _FormTextInput,
  FormSelectInput as _FormSelectInput,
  FormFormattedInput as _FormFormattedInput,
} from 'src/components/form-inputs';

// Custom label styles to fix positioning and add error styling
export const customLabelStyles = css`
  &.MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, 10px) scale(0.75) !important;
  }

  &.Mui-error {
    color: ${({ theme }) => theme.colors.red[60]} !important;
  }
`;

// Container Styles
export const MedIntakeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0; /* Allow flex child to shrink */
  width: 100%;
`;

export const FieldWrapper = styled.div`
  ${({ theme: { spaces } }) => css`
    margin-bottom: ${spaces[9]};
  `}
`;

export const ConditionalWrapper = styled.div`
  ${({ theme: { spaces, colors } }) => css`
    padding-left: ${spaces[5]};
    border-left: 1px solid ${colors.grey[80]};
  `}
`;

// Form Input Styles
export const StyledFormTextInput = styled(_FormTextInput)`
  margin-bottom: ${({ theme: { spaces } }) => spaces[3]};
`;

export const StyledFormFormattedInput = styled(_FormFormattedInput)`
  margin-bottom: ${({ theme: { spaces } }) => spaces[3]};
`;

export const FormSelectInput = styled(_FormSelectInput)`
  margin-bottom: ${({ theme: { spaces } }) => spaces[4]};
  ${space}
`;

export const TextInputField = styled.input<{ hasError?: boolean }>`
  ${({ theme: { colors, spaces }, hasError }) => css`
    width: 100%;
    padding: ${spaces[4]};
    border: 1px solid ${hasError ? colors.red[55] : colors.grey[80]};
    border-radius: 4px;
    background-color: ${colors.white};
    font-size: 16px;
    color: ${colors.gray40};

    &:focus {
      outline: none;
      border-color: ${hasError ? colors.red[55] : colors.blue[55]};
      box-shadow: 0px 1px 5px ${hasError ? colors.basicShadow : colors.blueShadow};
    }

    &::placeholder {
      color: ${hasError ? colors.red[60] : colors.grey[60]};
    }
  `}
`;

// Radio Button Styles
export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const RadioLabel = styled.div<{ selected?: boolean; hasError?: boolean }>`
  ${({ theme: { colors, spaces }, selected, hasError }): string => {
    const getBorderColor = (): string => {
      if (hasError) {
        return colors.red[55];
      }
      if (selected) {
        return colors.primaryBlue;
      }
      return colors.grey[80];
    };

    return css`
      text-align: center;
      flex-basis: calc(50% - 5px);
      background-color: ${selected ? colors.white : colors.grey[100]};
      border: 1px solid;
      border-color: ${getBorderColor()};
      border-radius: 4px;
      padding: ${spaces[4]};
      cursor: pointer;
    `;
  }}
`;

export const RadioLabelText = styled(Typography.Body).attrs({ size: 'medium' })`
  ${({ theme: { colors } }) => css`
    color: ${colors.gray40};
  `}
`;

export const Radio = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
`;

// Typography Styles
export const QuestionText = styled(Typography.Body).attrs({ size: 'medium' })`
  ${({ theme: { colors, spaces } }) => css`
    color: ${colors.gray40};
    margin-bottom: ${spaces[4]};
    font-weight: 500;
    text-align: center;
  `}
`;
